<div class="container">
<!--  <p>token received is {{ token }}</p>-->
  <ng-container [ngSwitch]="currentStep$ | async">
    <div *ngSwitchCase="Step.LOADING">
      <div class="img-div">
        <img src="assets/email-confirm-success.svg" >
        <h2>Thank you for subscribing to Akl Bayti</h2>
        <p>Please wait while we confirm your email.</p>
      </div>
    </div>
    <div *ngSwitchCase="Step.SUCCESS">
      <div class="img-div">
        <img src="assets/email-confirm-success.svg" >
        <h1 i18n>Thank you for subscribing to Akl Bayti</h1>
        <p i18n>Your email has been confirmed successfully.</p>
        <button class="button-primary" routerLink="/" i18n>Back to Home</button>
      </div>
    </div>
    <div *ngSwitchCase="Step.FAILED">
      <div class="img-div">
        <img src="assets/email-confirm-failed.svg" >
        <h1 i18n>There was an error confirming your email</h1>
        <p i18n>Please confirm the link you clicked is correct or contact support.</p>
        <button class="button-primary" routerLink="/" i18n>Back to Home</button>
      </div>
    </div>
  </ng-container>
</div>
